import { useEffect, useState } from "react";
import { Table } from "antd";
import { Form, Modal } from "react-bootstrap";
import swal from "sweetalert";
import formatError from "../../services/FormatError";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import {
  createExcelSheet,
  deleteExcelById,
  fetchAllExcelSheets,
  updateExcelSheet,
} from "../../services/TemplateManagementService";
import { dateFormatter } from "./BuyerProfile";
import { t } from "i18next";


function TemplateManagement() {
  const [excelData, setExcelData] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, updateGridFilter] = useState("");

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [addExcelSheet, setAddExcelSheet] = useState({
    cond: false,
    data: {
      name: "",
      file: "",
      desc: "",
    },
  });

  const [addTriggered, setAddTriggered] = useState(false);

  useEffect(() => {
    getExcelSheetsData();
  }, []);

  const getExcelSheetsData = () => {
    fetchAllExcelSheets()
      .then((res) => {
        const response = res.data?.result ?? [];
        // console.log("response0000", response);

        setExcelData({
          original: [...response],
          filtered: [...response],
        });

        setTableParams((prevState) => ({
          ...prevState,
          total: response?.length,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridData = (value) => {
    updateGridFilter(value);

    if (value !== "") {
      const filteredData = excelData.original.filter((item) =>
        item?.name.toLowerCase().includes(value.toLowerCase())
      );

      setExcelData((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setExcelData((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onAddExcelSheet = () => {
    setAddExcelSheet((prevState) => ({
      ...prevState,
      cond: true,
    }));
  };

  const onUpdateExcelSheet = (id) => {
    updateExcelSheet(id)
      .then((res) => {
        getExcelSheetsData();
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const ondownloadExcel = (name, base64) => {
    const binaryData = atob(base64);

    const byteNumbers = new Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
      byteNumbers[i] = binaryData.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const onDeleteExcelSheet = (id) => {
   swal({
          title: t("hconfirm"),
          text: t("confirmationDelete"),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willdelete) => {
          if(willdelete){
            deleteExcelById(id)
              .then((res) => {
                getExcelSheetsData();
              })
              .catch((error) => {
                formatError(error.response?.data?.error);
              });
          }
        });
  };

  const onHide = () => {
    setAddTriggered(false);

    setAddExcelSheet({
      cond: false,
      data: {
        name: "",
        file: "",
        desc: "",
      },
    });
  };

  const onChangeFile = (event) => {
    const file = event.target.files[0];

    // Validate file type
    if (!file || !file.name.match(/\.(xls|xlsx)$/i)) {
      swal("Oops", t("hselectvalidexcel"), "error");
      return;
    }

    // Validate file size
    if (file.size > 25 * 1024 * 1024) {
      // 25MB
      swal("Oops", t("hmax25"), "error");
      return;
    }

    // Read file as base64
    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = reader.result;
      setUpdate("file", base64Data.split("base64,")?.[1]);
    };
    reader.readAsDataURL(file);
  };

  const setUpdate = (key, value) => {
    setAddExcelSheet((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [key]: value,
      },
    }));
  };

  const onUploadExcelSheet = (e) => {
    e.preventDefault();

    if (addExcelSheet?.data?.name !== "" && addExcelSheet?.data?.file !== "") {
      createExcelSheet(
        addExcelSheet?.data?.name,
        addExcelSheet?.data?.file,
        addExcelSheet?.data?.desc
      )
        .then((res) => {
          setAddTriggered(false);
          onHide();
          getExcelSheetsData();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setAddTriggered(true);
    }
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: t("nameInput"),
      dataIndex: "name",
      sorter: true,
      width: "20%",
    },
    {
      title: t("descriptionInput"),
      dataIndex: "description",
      sorter: true,
      width: "20%",
    },
    {
      title: t("businessDetailsCreatedDate"),
      dataIndex: "createdat",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: t("userCollumn6"),
      dataIndex: "used",
      sorter: true,
      width: "20%",
      render: (obj, record) => {
        return (
          <div className="d-flex align-items-center">
            <input
              type="checkbox"
              className="excelsheet-checkbox me-3"
              checked={obj}
              onChange={(e) => onUpdateExcelSheet(record?.id)}
              disabled={obj}
            />
            <p className="mb-0">{obj === true ? "Active" : "Inactive"}</p>
          </div>
        );
      },
    },
    {
      title: t("buyerProfileCulumn7"),
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              style={{ fontSize: "20px" }}
              class="btn btn-info btn-xs light px-2 me-2"
              onClick={() => ondownloadExcel(record?.name, record?.file)}
            >
              <i className="fa fa-download"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="btn btn-danger btn-xs light px-2"
              onClick={() => onDeleteExcelSheet(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 6H5H21"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <>
      <div className="row">
        <div style={{ marginBottom: "1rem" }} className="card col-lg-12">
          <div className="card-header d-sm-flex d-block">
            <div className="d-flex me-auto mb-sm-0">
              <h4 className="card-title">{t("sidebarItemTemplateManagement")}</h4>
            </div>
            <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
            <div style={{ paddingLeft: "12px" }}>
              <a
                href="javascript:void(0);"
                class="btn btn-info"
                onClick={onAddExcelSheet}
              >
                + {t("haddTemplate")}
              </a>
            </div>
          </div>

          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={excelData.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </div>

      {addExcelSheet?.cond && (
        <Modal
          className="modal fade"
          show={addExcelSheet?.cond}
          onHide={onHide}
        >
          <div role="document">
            <div>
              <Form>
                <div className="modal-header">
                  <h4 className="modal-title fs-20">{t("haddTemplate")}</h4>
                  <button type="button" className="close btn" onClick={onHide}>
                    <span>×</span>
                  </button>
                </div>

                <div className="modal-body">
                  <i
                    className="flaticon-cancel-12 close"
                    data-dismiss="modal"
                  ></i>

                  <div className="add-contact-box">
                    <div className="add-contact-content">
                      <div
                        className={`form-group ${
                          addTriggered && addExcelSheet?.data?.name === ""
                            ? "mb-1"
                            : "mb-3"
                        }`}
                      >
                        <label htmlFor="name" className="mb-1">
                          <span className="text-danger">*</span>
                          &ensp;
                          <strong>{t("nameInput")}</strong>
                        </label>
                        <input
                          id="name"
                          type="text"
                          placeholder="Name"
                          className="form-control"
                          value={addExcelSheet?.data?.name}
                          onChange={(e) => setUpdate("name", e.target.value)}
                        />
                      </div>

                      {addTriggered && addExcelSheet?.data?.name === "" && (
                        <div className="text-danger fs-12 mb-3">
                         {t("hrequiredName")}
                        </div>
                      )}
                    </div>

                    <div className="add-contact-content">
                      <div
                        className={`form-group ${
                          addTriggered && addExcelSheet?.data?.file === ""
                            ? "mb-1"
                            : "mb-3"
                        }`}
                      >
                        <label htmlFor="file" className="mb-1">
                          <span className="text-danger">*</span>
                          &ensp;
                          <strong>{t("hfile")}</strong>
                        </label>
                        <input
                          id="file"
                          type="file"
                          accept=".xls,.xlsx"
                          style={{ height: "100%" }}
                          className="form-control"
                          onChange={onChangeFile}
                        />
                      </div>
                      {addTriggered && addExcelSheet?.data?.file === "" && (
                        <div className="text-danger fs-12 mb-3">
                          {t("hfilerequired")}
                        </div>
                      )}
                    </div>

                    <div className="add-contact-content">
                      <div className="form-group mb-3">
                        <label htmlFor="textarea" className="mb-1">
                          <strong>{t("descriptionInput")}</strong>
                        </label>
                        <textarea
                          id="textarea"
                          name="Description"
                          cols={30}
                          rows={8}
                          className="form-control bg-transparent excelsheet-textarea"
                          placeholder="Description"
                          value={addExcelSheet?.data?.desc}
                          onChange={(e) => setUpdate("name", e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    style={{ background: "#808080", color: "#fff" }}
                    onClick={onHide}
                  >
                    <i className="flaticon-delete-1"></i>
                    &nbsp;{t("globalDiscardButton")}
                  </button>

                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={onUploadExcelSheet}
                  >
                    {t("add")}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default TemplateManagement;
